import { useEffect, useState } from 'react';
import { getInitials } from '../../utils';
import {
  useSelectedClient,
  useFetch
} from '../../uni-comms-api/hooks/authentication';

interface UseTeamsParams {
  expandUsers?: boolean;
}

interface TeamData {
  _id: string;
  name: string;
  initials: string;
  users: Array<{
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
  }>;
}

export default (params: UseTeamsParams = {}) => {
  const { selectedClient } = useSelectedClient();
  const [teams, setTeams] = useState<TeamData[]>([]);

  const { data, loading, error, refresh } = useFetch<{ items: TeamData[] }>(
    `${process.env.AUTH_URL || ''}/clients/${selectedClient}/teams?${
      params?.expandUsers ? 'expandUsers=true' : ''
    }`
  );

  useEffect(() => {
    setTeams(
      data && data.items.length
        ? data.items.map(team => ({
            ...team,
            initials: getInitials(team.name) as string
          }))
        : []
    );
  }, [data]);

  return { teams: teams || [], loading, error, refresh };
};
